import { render, staticRenderFns } from "./WorkerInfo.vue?vue&type=template&id=494ede96&"
import script from "./WorkerInfo.vue?vue&type=script&lang=js&"
export * from "./WorkerInfo.vue?vue&type=script&lang=js&"
import style0 from "./WorkerInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('494ede96')) {
      api.createRecord('494ede96', component.options)
    } else {
      api.reload('494ede96', component.options)
    }
    module.hot.accept("./WorkerInfo.vue?vue&type=template&id=494ede96&", function () {
      api.rerender('494ede96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WorkerInfo.vue"
export default component.exports